import { gql } from '@apollo/client';
import { Fragments } from 'api/fragments';


export const ADD_ANNOTATION = gql`
  mutation addAnnotation($annotation: AnnotationRequestInput!) {
    addAnnotation(annotation: $annotation) {
      ...Annotation
    }
  }

  ${Fragments.Annotation}
`;

export const DELETE_ANNOTATION = gql`
  mutation deleteAnnotation($id: ID!) {
    deleteAnnotation(id: $id) {
      ...Annotation
    }
  }

  ${Fragments.Annotation}
`;

export const UPDATE_ANNOTATION = gql`
  mutation updateAnnotation($annotation: AnnotationRequestInput!) {
    updateAnnotation(annotation: $annotation) {
      ...Annotation
    }
  }

  ${Fragments.Annotation}
`;

export const ANNOTATIONS_QUERY = gql`
  query annotations($startMs: Long!, $endMs: Long!) {
    annotations(startMs: $startMs, endMs: $endMs) {
      ...Annotation
    }
  }
  
  ${Fragments.Annotation}
`;
